import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import logo from "../../assets/BTPL_Logo.jpg";
import "./ProductNavbar.scss";

function ProductNavbar() {
  const navigate = useNavigate();
  const location = useLocation();

  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showProducts, setShowProducts] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.classList.add("nav-open");
    } else {
      document.body.classList.remove("nav-open");
    }

    return () => document.body.classList.remove("nav-open");
  }, [isMobileMenuOpen]);

  // Navigates back to the Main Project Home Page
  const goToHomeSection = (section) => {
    navigate("/", {
      state: {
        scrollTo: section,
      },
    });
    setIsMobileMenuOpen(false);
    setShowProducts(false);
  };

  const closeMenus = () => {
    setIsMobileMenuOpen(false);
    setShowProducts(false);
  };

  // Navigates to a different product and scrolls to the top
  const handleProductNavigation = () => {
    closeMenus();
    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, 0);
  };

  // Stays on the CURRENT product page and just scrolls to the top (Hero Section)
  const handleLogoClick = () => {
    closeMenus();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  const currentPath = location.pathname;

  return (
    <>
      <div
        className={`overlay-bg ${isMobileMenuOpen ? "overlay-bg--open" : ""}`}
        onClick={closeMenus}
      />

      <header
        className={`navbar
                    ${isScrolled ? "navbar--scrolled" : ""}
                    ${isMobileMenuOpen ? "navbar--overlay" : ""}
                `}
      >
        {/* Logo - Scrolls to top of CURRENT product page */}
        <div className="navbar__left" onClick={handleLogoClick}>
          <img src={logo} alt="Belageri Technologies" className="logo" />
          <span className="navbar__title">Belageri Technologies</span>
        </div>

        {/* Right Side */}
        <div className="navbar__right">
          <nav
            className={`nav-links ${
              isMobileMenuOpen ? "nav-links--overlay nav-links--open" : ""
            }`}
          >
            <div className="nav-link" onClick={() => goToHomeSection("hero")}>
              Home
            </div>

            <div className="nav-link" onClick={() => goToHomeSection("about")}>
              About Us
            </div>

            <div
              className="nav-link"
              onClick={() => goToHomeSection("workwithus")}
            >
              Work With Us
            </div>

            {/* Smart Products Dropdown */}
            <div className="products-dropdown">
              <div
                className="nav-link"
                onClick={() => setShowProducts(!showProducts)}
              >
                Products {showProducts ? "▲" : "▼"}
              </div>

              {showProducts && (
                <div className="submenu">
                  {currentPath !== "/runmytransport" && (
                    <Link
                      className="submenu-link"
                      to="/runmytransport"
                      onClick={handleProductNavigation}
                    >
                      Run My Transport
                    </Link>
                  )}

                  {currentPath !== "/reward" && (
                    <Link
                      className="submenu-link"
                      to="/reward"
                      onClick={handleProductNavigation}
                    >
                      Reward
                    </Link>
                  )}
                </div>
              )}
            </div>

            <div
              className="nav-link"
              onClick={() => goToHomeSection("services")}
            >
              Services
            </div>

            <div
              className="nav-link"
              onClick={() => goToHomeSection("testimonials")}
            >
              Testimonials
            </div>

            <div
              className="nav-link"
              onClick={() => goToHomeSection("contact")}
            >
              Contact Us
            </div>
          </nav>

          {/* Hamburger */}
          <button
            className={`hamburger ${isMobileMenuOpen ? "hamburger--open" : ""}`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <span className="hamburger__line"></span>
            <span className="hamburger__line"></span>
            <span className="hamburger__line"></span>
          </button>
        </div>
      </header>
    </>
  );
}

export default ProductNavbar;
